import styled, { css } from 'styled-components';
import { Sizes } from 'styles/constants';

import { Colors } from 'styles/enums';
import { mediaQueries } from 'styles/helpers';

export const PaymentSectionWrapper = styled.div`
  max-width: ${Sizes.maxWidth}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 0px 18px;
`;

export const PaymentTitleWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  max-width: 60%;
  padding-bottom: 70px;
  gap: 24px;
  p {
    font-size: 18px;
  }
`;

export const PaymentCardTitleWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  p, span {
    font-size: 18px;
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  gap: 10px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-areas:
    'card'
    'points'
    'bank';

  ${mediaQueries(
    'lg',
    css`
      grid-template-columns: repeat(12, minmax(0, 1fr));
      grid-template-areas:
        'card card card card card card card points points points points points'
        'card card card card card card card bank bank bank bank bank';
      `
  )}
`;

export const CardPaymentSectionWrapper = styled.div`
  grid-area: card;
  border: 4px solid ${Colors.Yellow.base100};
  border-radius: 10px;
  background: ${Colors.Yellow.base010};
  padding: 34px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`;

export const PaymentInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > button {
    width: 100%;
    justify-content: center;
  }
`;

export const PaymentSectionInputsWrapper = styled.div``;

export const PaymentSectionOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const PaymentInput = styled.input`
  width: 100%;
  padding: 10px;
  height: 56px;
  border: 1px solid ${Colors.Primary.base100};
  border-radius: 4px;
  font-size: 16px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type=number] {
    appearance: textfield;
    -moz-appearance: textfield;
  }
`;

export const PointsSectionWrapper = styled.div`
  grid-area: points;
   border: 4px solid ${Colors.Turkish.base100};
  border-radius: 10px;
  background: ${Colors.Turkish.base010};
  padding: 34px;
  & > button, & > a {
    width: 100%;
    justify-content: center;
  }
`;

export const BankTransferSectionWrapper = styled.div`
  grid-area: bank;
  border: 4px solid ${Colors.Primary.base100};
  border-radius: 10px;
  background: transparent;
  padding: 34px;

`;

export const PaymentInputSection = styled.label<{ $isSelected?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    cursor: pointer;
    background-color: white;
    border-radius: 30px;
    border: 2px solid ${Colors.Primary.base100};
    color: ${Colors.Primary.base100};
    height: 40px;
    width: 141px;
    &:hover {
      background-color: ${Colors.Turkish.base020};
      color: ${Colors.Primary.base100};
    }
`;

export const PaymentSelectInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  position: fixed;

  &:checked + ${PaymentInputSection} {
    background: ${Colors.Turkish.base100};
  }
`;
